document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor?.addEventListener("click", function (e) {
      const href = this.getAttribute("href");
      if (!href || href === "#") return;
      e.preventDefault();
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
        });
      }
    });
  });

  document.addEventListener("click", function (event) {
    //-------------------------------------------------------
    const openButton = event.target.closest("#openSizeChart");
    if (openButton) {
      const parentContainer = openButton.closest(".product_wrapper_container");
      if (parentContainer) {
        const nextElement = parentContainer.nextElementSibling;
        nextElement?.classList.add("is-visible");
      }
    }
    if (event.target.closest("#closePopup")) {
      popup.classList.remove("is-visible");
    }
    //-------------------------------------------------------
    if (!event.target.closest(".pv2-accordion__button")) return;
    const button = event.target.closest(".pv2-accordion__button");
    const buttonToggle = button.querySelector(".pv2-accordion__toggle");
    const containerContent = button.nextElementSibling;
    if (!buttonToggle || !containerContent) return;
    document.querySelectorAll(".pv2-accordion__toggle").forEach((toggle) => {
      if (toggle !== buttonToggle) {
        toggle.classList.remove("open");
      }
    });
    document.querySelectorAll(".pv2-accordion__content").forEach((content) => {
      if (content !== containerContent) {
        content.style.maxHeight = null;
      }
    });
    buttonToggle.classList.toggle("open");
    containerContent.style.maxHeight = containerContent.style.maxHeight
      ? null
      : `${containerContent.scrollHeight}px`;
  });

  const varSelect = document.querySelector(
    ".product-form input.product-variant-id"
  );
  const bisTrigger = document.querySelector(".product_bis_trigger");
  if (varSelect && bisTrigger) {
    varSelect.addEventListener("change", function () {
      const selectedVariantId = this.value;
      bisTrigger.setAttribute("data-variant-id", selectedVariantId);
    });
  }

  $(document).ready(function () {
    let swiper = $(".Product_main_custom_slider").slick({
      arrows: false,
      asNavFor: ".product_thumbnail_custom_slider",
      slidesToShow: 1,
      lazyLoad: "ondemand",
      slidesToScroll: 1,
      prevArrow:
        '<button class="main-slider prev-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
      nextArrow:
        '<button class="main-slider next-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg></button>',
      infinite: false,
      responsive: [
        {
          breakpoint: 1008,
          settings: {
            dots: true,
            arrows: false,
          },
        },
      ],
    });

    let productThumbnailSlider = $(".product_thumbnail_custom_slider").slick({
      arrows: true,
      focusOnSelect: true,
      vertical: true,
      verticalSwiping: true,
      lazyLoad: "ondemand",
      asNavFor: ".Product_main_custom_slider",
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow:
        '<button class="thumb-slider prev-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
      nextArrow:
        '<button class="thumb-slider next-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg></button>',
      infinite: false,
    });
    $(".product-media-slider").on(
      "init reInit afterChange",
      function (event, slick, currentSlide, nextSlide) {
        let slideHeight = $(".slick-current img").height();
        $(".product-media-slider").css("height", slideHeight + "px");
      }
    );
  });
});